module.exports = __webpack_public_path__ + "media/Posadas_Hoteles_V7.26eed876.mp4";